import React from 'react'
import styles from './styles.module.css'

const ChangelogFilterGroupTitle = ({ children }) => {
  return (
    <div className={styles.checklistTitle}>
      <span>{children}</span>
    </div>
  )
}

export default ChangelogFilterGroupTitle
